import React, { useState, useEffect } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorTicketDetailsView from './SupervisorTicketDetailsView';
import { fetchSupervisorTicketsPerBank } from '../../api/supervisor';
import './SupervisorTicketsPerBankView.css';

const SupervisorTicketsPerBankView = ({ row, product, numero, date, rawDate, tirage, onBack }) => {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchSupervisorTicketsPerBank({ tirage, date: rawDate, product, numbers: numero, bank: row.bank })
      .then((data) => { if (!cancelled) setTickets(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les tickets — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tirage, rawDate, product, numero, row.bank]);

  const totalPoints = tickets.reduce((s, r) => s + r.points, 0);
  const totalAmount = tickets.reduce((s, r) => s + r.amount, 0);

  if (selectedTicket !== null) {
    return (
      <SupervisorTicketDetailsView
        ticket={selectedTicket}
        bankDesc={row.desc}
        date={date}
        onBack={() => setSelectedTicket(null)}
      />
    );
  }

  return (
    <SupervisorLayout>
      <div className="svtpb-wrapper">
        <div className="svtpb-card">
          <div className="svtpb-card-header">
            <span className="svtpb-card-title">Tickets per Bank</span>
          </div>

          <div className="svtpb-info">
            <div className="svtpb-info-row">
              <span className="svtpb-info-label">Bank</span>
              <span className="svtpb-info-val">{row.desc}</span>
            </div>
            <div className="svtpb-borlette-row">
              <span className="svtpb-borlette-label">{product} :</span>
              <span className="svtpb-borlette-val">{numero}</span>
            </div>
            <div className="svtpb-info-row">
              <span className="svtpb-date-box">Date</span>
              <span className="svtpb-date-val">{date} :</span>
            </div>
          </div>

          <div className="svtpb-table-bar"></div>

          {error && <p className="svtpb-error">{error}</p>}
          {loading && <p className="svtpb-loading">Chargement...</p>}

          {!loading && !error && (
            <table className="svtpb-table">
              <thead>
                <tr>
                  <th>Sequence</th>
                  <th>Ticket</th>
                  <th>Point's Total</th>
                  <th>Amount</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((r, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'svtpb-row-even' : 'svtpb-row-odd'}>
                    <td>{r.sequence}</td>
                    <td>
                      <span className="svtpb-ticket-box svtpb-ticket-link" onClick={() => setSelectedTicket(r.sequence)}>
                        {r.ticket}
                      </span>
                    </td>
                    <td>{r.points.toFixed(2)}</td>
                    <td>{r.amount.toFixed(2)}</td>
                    <td>{r.time}</td>
                  </tr>
                ))}
                <tr className="svtpb-total-row">
                  <td colSpan="2"><strong>Total:</strong></td>
                  <td><strong>{totalPoints.toFixed(2)}</strong></td>
                  <td><strong>{totalAmount.toFixed(2)}</strong></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="svtpb-actions">
          <button className="svtpb-back-btn" onClick={onBack}>↩</button>
          <button className="svtpb-menu-btn">☰<br /><span>Menu</span></button>
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorTicketsPerBankView;
